const config = {
  api_host: "https://istorage-stag.fpt.vn",
  menu_id: {
    dashboard: "631eec586885973450bfb51d",
    user: "631eeda26885973450bfb51e",
    storage: "631eee3b6885973450bfb51f",
  }
}

export default config;